import classNames from 'clsx';
import { isNil } from 'ramda';
import React, { ReactNode, VFC } from 'react';
import { HotKeyTip } from 'reactApp/ui/HotKeyTip/HotKeyTip';
import { ArrowUpSmallIcon,VerifiedIcon } from 'reactApp/ui/VKUIIcons';

import styles from './DropdownItemAction.css';

interface Props {
    mod?: string;
    asc?: boolean;
    withStatus?: boolean;
    icon?: ReactNode;
    active?: boolean;
    text: string;
    hotkey?: string;
    id?: string;
}

const renderStatus = ({ active, asc }: { active?: boolean; asc?: boolean }) => {
    if (!active) {
        return <div className={styles.status} />;
    }

    if (isNil(asc)) {
        return (
            <div className={styles.status}>
                <VerifiedIcon />
            </div>
        );
    }

    return (
        <div
            className={classNames({
                [styles.status]: true,
                [styles.status_flip]: asc,
            })}
        >
            <ArrowUpSmallIcon data-qa-id={asc ? 'sortAsc' : 'sortDesc'} />
        </div>
    );
};

export const DropdownItemAction: VFC<Props> = ({ mod, asc, icon, text, active, withStatus, hotkey, id }) => {
    return (
        <div className={classNames(styles.root, { [styles[`root_${mod}`]]: Boolean(mod), [styles[`root_${id}`]]: id })}>
            {withStatus && renderStatus({ active, asc })}
            {!!icon && <div className={styles.icon}>{icon}</div>}
            <div className={styles.text}>{text}</div>
            {hotkey && (
                <div className={styles.hotkeyWrapper}>
                    {' '}
                    <HotKeyTip text={hotkey} />
                </div>
            )}
        </div>
    );
};
